import React from "react";

import { LoadingButton } from "@mui/lab";
import { Box, Grid, TextField } from "@mui/material";

import GenericDialog from "components/shared/generic-dialog";

export interface NewAttributeFormState {
  name: string;
  prompt: string;
  systemPrompt: string;
}

interface AddAttributeFormProps {
  isOpen: boolean;
  handleClose: () => void;
  newAttributeFormState: {
    name: string;
    prompt: string;
    systemPrompt: string;
  };
  setNewAttributeFormState: (newState: NewAttributeFormState) => void;
  handleSubmit: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

const AddGenerateAttributeForm = ({
  isOpen,
  handleClose,
  newAttributeFormState,
  setNewAttributeFormState,
  handleSubmit,
  isLoading,
  isDisabled,
}: AddAttributeFormProps) => {
  return (
    <GenericDialog
      title="Add Generate Attribute"
      width="md"
      hasXCloseBtn
      open={isOpen}
      handleDialogClose={handleClose}
      data-testid="add-attribute-dialog"
    >
      <Grid xs={12} item>
        <form noValidate autoComplete="off">
          <Box
            sx={{ height: "70vh", width: "100%" }}
            display="flex"
            flexDirection="column"
            gap={4}
            marginTop={4}
          >
            <TextField
              required
              label="Name"
              inputProps={{
                "data-testid": "add-attribute-name-field",
              }}
              value={newAttributeFormState.name}
              onChange={(event) =>
                setNewAttributeFormState({
                  ...newAttributeFormState,
                  name: event.target.value,
                })
              }
            />
            <TextField
              required
              label="Prompt"
              inputProps={{
                "data-testid": "add-attribute-prompt-field",
              }}
              value={newAttributeFormState.prompt}
              onChange={(event) =>
                setNewAttributeFormState({
                  ...newAttributeFormState,
                  prompt: event.target.value,
                })
              }
            />
            <TextField
              required
              label="System Prompt"
              inputProps={{
                "data-testid": "add-attribute-system-prompt-field",
              }}
              value={newAttributeFormState.systemPrompt}
              onChange={(event) =>
                setNewAttributeFormState({
                  ...newAttributeFormState,
                  systemPrompt: event.target.value,
                })
              }
            />
          </Box>
          <LoadingButton
            color="primary"
            onClick={handleSubmit}
            loading={isLoading}
            disabled={isDisabled}
            loadingPosition="center"
            variant="contained"
            data-testid="add-attribute-btn"
          >
            Add Attribute
          </LoadingButton>
        </form>
      </Grid>
    </GenericDialog>
  );
};

export default AddGenerateAttributeForm;
